export default __webpack_public_path__ + "static/icon_character_haikei-1.0.0.png";